/**
 * Model for UserEcho information
 */
export class UserEcho {
  /**
   * UserEcho SSO Token
   */
  userEchoToken: string;

  /**
   * Primary phone
   */
  primaryPhone: string;

  /**
   * Last name
   */
  lastName: string;

  /**
   * Recid
   */
  recid: string;

  /**
   * First Name
   */
  firstName: string;

  /**
   * Primary email
   */
  primaryEmail: string;

  /**
   * Parses info from the web service
   * @param data User info as returned by the API
   * @returns {UserEcho} Parsed UserEcho info
   */
  static parse(data: any): UserEcho {
    return Object.assign(new UserEcho(), {
      userEchoToken: data.userEchoToken,
      primaryPhone: data.primaryPhone,
      lastName: data.lastName,
      recid: data.recid,
      firstName: data.firstName,
      primaryEmail: data.primaryEmail
    });
  }
}
